import { useIntl } from "react-intl";
import { Link as NavLink } from "react-router-dom";
import styles from "./Layout.module.scss";
import { Social } from "./Social";
import preval from "preval.macro";
import { SITE_KIND } from "../../config";

type FooterProps = {
  menu?: MenuItem[];
};

type MenuItem = {
  location: string;
  id?: string;
  value?: string;
};

export default function Footer(props: FooterProps) {
  const { formatMessage } = useIntl();
  const dateTimeStamp = preval`module.exports = new Date().toLocaleString();`;

  return (
    <footer className={styles.footer}>
      <nav className={styles.footerContent}>
        <ul className={styles.menu}>
          <li>{`©${SITE_KIND}`} {new Date().getFullYear()}</li>
          {props.menu?.map((item) => (
            <li key={item.location}>
              <NavLink to={item.location}>
                {item.id ? formatMessage({ id: item.id }) : item.value}
              </NavLink>
            </li>
          ))}
        </ul>
        <Social />

        <div style={{ display: "none" }} hidden>
          {dateTimeStamp}
        </div>
      </nav>
    </footer>
  );
}
